<script setup lang="ts">
import {BaseWidget} from "@/laboratory/components/dashboard/dashboard";
import WidgetContainer from "@/laboratory/components/dashboard/components/widget/WidgetContainer.vue";
import WidgetHeader from "@/laboratory/components/dashboard/components/widget/WidgetHeader.vue";
import WidgetTitle from "@/laboratory/components/dashboard/components/widget/WidgetTitle.vue";
import InformationTooltip from "@/core/components/tooltips/InformationTooltip.vue";

defineProps<{
    widget: BaseWidget
}>();
</script>

<template>
  <WidgetContainer class="space-y-2">
    <WidgetHeader>
      <WidgetTitle class="flex items-center gap-2">
        {{ widget.title }} <InformationTooltip v-if="widget.description" class="w-4 h-4">
          <div class="max-w-md">
            {{ widget.description }}
          </div>
        </InformationTooltip>
      </WidgetTitle>
    </WidgetHeader>
    <div>
      <slot />
    </div>
  </WidgetContainer>
</template>

<style scoped>

</style>
